import { http } from '@/core/helpers/http.helper';
import { ApiResource } from '@/core/models/api-resource.interface';
import { LocationQuery } from 'vue-router';
import { User } from '../../users/user.interface';

export class UserService {
   async getUsers(teamId: number, query?: LocationQuery) {
      const response = await http.get<ApiResource<Array<User>>>(`/teams/${teamId}/users`, { params: { ...query } });
      return response.data;
   }

   async postUsersBatch(teamId: number, users: Array<User>) {
      const response = await http.post<Array<User>>(`/teams/${teamId}/users-batch`, { users });
      return response.data;
   }
   async deleteUsersBatch(teamId: number, users: Array<User>) {
      const response = await http.delete<Array<number>>(`/teams/${teamId}/users-batch`, { data: { users } });
      return response.data;
   }
}
